import { ImprovedShopFundraiser } from "../../../Interfaces/Fundraiser";

const fundraiser: ImprovedShopFundraiser = {
  id: 13,
  org: 4,
  org_name: "FundraiseWithMamFam",
  org_logo_url: "",
  fundraiser_name: "Sample Fundraiser",
  fundraiser_code: "FAKEFAKE123",
  start_date: "2025-06-21",
  end_date: `${new Date().getFullYear()}-12-31`,
  primary_theme_hex: "",
  secondary_theme_hex: "",
  primary_organization_hex: "",
  secondary_organization_hex: "",
  fundraiser_purpose_message:
    "This is a sample fundraiser created to demonstrate the participant shop features. Feel free to explore the shop.",
  allow_ship_to_org: false,
  allow_ship_to_participant: false,
  org_shipping_info: null,
};

export default fundraiser;
